import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import {injectIntl, FormattedMessage} from "@irati/utils/lang"

import {determineStatusColor} from "../../helpers/color"
import {PillBadge} from "../../ui/PillBadge"
import {Dot} from "../../ui/Dot"


class StatusPillBadge extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    formatMessage: PropTypes.func.isRequired,
    validationStatus: PropTypes.string.isRequired,
    onDetermineColor: PropTypes.func,
    contentKey: PropTypes.string
  }

  static defaultProps = {
    onDetermineColor: determineStatusColor,
    contentKey: "insights.schedule.validation.status"
  }


  render() {
    const {className, validationStatus, onDetermineColor, contentKey} = this.props

    return (
      <PillBadge className={className}>
        <FormattedMessage id={`${contentKey}.${validationStatus}`} />
        <Dot color={onDetermineColor(validationStatus)} />
      </PillBadge>
    )
  }
}

export default injectIntl(StatusPillBadge)
